module.exports = __webpack_public_path__ + "static/media/calender_circle.36e5df53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calender_circle.svg
// module id = 474
// module chunks = 21